export const homePageTranslations = {
  en: {
    'home.pageTitle': 'Welcome to Vaiu',
    'home.pageSubtitle': 'The future of decentralized commerce.',
    'home.startAdvocating': 'Start Advocating',
    'home.discoverMerchants': 'Discover Merchants',
    'home.stores': 'Stores',
    'home.listings': 'Listings',
    'home.makeMoney': 'Make Money',
    'home.atomicSubtitle': 'Discover and support businesses across Atomic Marketplace.',
    'home.vaiuSubtitle': 'Discover merchants, send money, and grow the network.',
  },
  es: {
    'home.pageTitle': 'Bienvenido a Vaiu',
    'home.pageSubtitle': 'El futuro del comercio descentralizado.',
    'home.startAdvocating': 'Empezar a Recomendar',
    'home.discoverMerchants': 'Descubrir Comercios',
    'home.stores': 'Tiendas',
    'home.listings': 'Anuncios',
  },
  fr: {
    'home.pageTitle': 'Bienvenue chez Vaiu',
    'home.pageSubtitle': "L'avenir du commerce décentralisé.",
    'home.startAdvocating': 'Commencer à Recommander',
    'home.discoverMerchants': 'Découvrir les Commerces',
    'home.stores': 'Boutiques',
    'home.listings': 'Annonces',
  },
  sq: {
    'home.pageTitle': 'Mirë se vini në Vaiu',
    'home.pageSubtitle': 'E ardhmja e tregtisë së decentralizuar.',
    'home.startAdvocating': 'Fillo Avokimin',
    'home.discoverMerchants': 'Zbuloni Tregtarët',
    'home.stores': 'Dyqanet',
    'home.listings': 'Listimet',
  },
  ru: {
    'home.pageTitle': 'Добро пожаловать в Vaiu',
    'home.pageSubtitle': 'Будущее децентрализованной коммерции.',
    'home.startAdvocating': 'Начать Продвижение',
    'home.discoverMerchants': 'Найти Продавцов',
    'home.stores': 'Магазины',
    'home.listings': 'Объявления',
  },

  el: {
    'home.pageTitle': 'Καλώς ήρθατε στο Vaiu',
    'home.pageSubtitle': 'Το μέλλον του αποκεντρωμένου εμπορίου.',
    'home.startAdvocating': 'Ξεκινήστε την Υποστήριξη',
    'home.discoverMerchants': 'Ανακαλύψτε Εμπόρους',
    'home.stores': 'Καταστήματα',
    'home.listings': 'Καταχωρήσεις',
  },
  de: {
    'home.pageTitle': 'Willkommen bei Vaiu',
    'home.pageSubtitle': 'Die Zukunft des dezentralen Handels.',
    'home.startAdvocating': 'Beginnen Sie mit dem Befürworten',
    'home.discoverMerchants': 'Entdecken Sie Händler',
    'home.stores': 'Geschäfte',
    'home.listings': 'Angebote',
  },

  sr: {
    'home.pageTitle': 'Добродошли у Ваиу',
    'home.pageSubtitle': 'Будућност децентрализоване трговине.',
    'home.startAdvocating': 'Почните са заговарањем',
    'home.discoverMerchants': 'Откријте трговце',
    'home.stores': 'Продавнице',
    'home.listings': 'Огласи',
  },
  pl: {
    'home.pageTitle': 'Witamy w Vaiu',
    'home.pageSubtitle': 'Przyszłość zdecentralizowanego handlu.',
    'home.startAdvocating': 'Zacznij Rekomendować',
    'home.discoverMerchants': 'Odkryj Sprzedawców',
    'home.stores': 'Sklepy',
    'home.listings': 'Ogłoszenia',
  },
  ro: {
    'home.pageTitle': 'Bun venit la Vaiu',
    'home.pageSubtitle': 'Viitorul comerțului descentralizat.',
    'home.startAdvocating': 'Începeți Susținerea',
    'home.discoverMerchants': 'Descoperiți Comercianți',
    'home.stores': 'Magazine',
    'home.listings': 'Listări',
  },
  pt: {
    'home.pageTitle': 'Bem-vindo ao Vaiu',
    'home.pageSubtitle': 'O futuro do comércio descentralizado.',
    'home.startAdvocating': 'Comece a Recomendar',
    'home.discoverMerchants': 'Descubra Comerciantes',
    'home.stores': 'Lojas',
    'home.listings': 'Listagens',
  },
};
